import { TAB_LIST_DASHBOARD } from '../../constants/article.constant';
import ArticlesComponent from '../../components/ManageArticles/articles';
import RequestComponent from '../../components/ManageArticles/requests';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import ResponseComponent from '../../components/ManageArticles/submissions';
import ProfileComponent from '../../components/ManageArticles/profile';
import AwardedPointsComponent from '../../components/ManageArticles/awarded-points';
import InvestmentsComponent from '../../components/ManageArticles/investments';
import MyArticleInvestorsComponent from '../../components/ManageArticles/my-investors';
import { useAtom } from 'jotai';
import { profileAtom } from '../../components/Settings/atom';
import SEO from '../../components/SEO';
import { generateSEOMetadata, dynamicPages } from '../../utils/seo';

const TAB_CONST = {
  ARTICLES: 'articles',
  REQUESTS: 'requests',
  SUBMISSIONS: 'submissions',
  PROFILE: 'profile',
  AWARDED_TWIGS: 'awarded-twigs',
  INVESTMENTS: 'investments',
  INVESTORS: 'investors'
};

const ManageArticle = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [profile] = useAtom(profileAtom);

  // Filter tabs based on creator status
  const getFilteredTabs = () => {
    if (profile?.isCreator) {
      return TAB_LIST_DASHBOARD;
    }
    // For non-creators, show Profile, Awarded Twigs, Submissions, and Investments
    return TAB_LIST_DASHBOARD.filter((tab) =>
      ['profile', 'awarded-twigs', 'submissions', 'investments'].includes(tab.value)
    );
  };

  const filteredTabs = getFilteredTabs();

  const handleSelectedTab = (value) => {
    setSearchParams({ tab: value });
  };

  useEffect(() => {
    if (!searchParams.get('tab')) {
      // Default to first available tab
      const defaultTab = filteredTabs[0]?.value || 'profile';
      setSearchParams({ tab: defaultTab });
    }
  }, [searchParams, setSearchParams, filteredTabs]);

  // Generate SEO metadata for manage articles page
  const seoMetadata = generateSEOMetadata.dynamicPage(
    dynamicPages['article/manage'].name,
    dynamicPages['article/manage'].url,
    dynamicPages['article/manage'].description
  );

  return (
    <div className="bg-white md:bg-06-seasalt-white min-h-[calc(100vh-80px)]">
      <SEO {...seoMetadata} />
      <div className="max-w-[1308px] mx-auto pb-10 px-0 md:px-10">
        <div className="flex mb-6 overflow-x-auto no-scrollbar sticky top-[48px] md:top-[56px] pt-10 bg-white md:bg-light-gray z-10">
          {filteredTabs.map((item) => (
            <div
              key={item.id}
              className="flex flex-col items-center min-w-[120px] gap-2 cursor-pointer"
              onClick={() => handleSelectedTab(item.value)}
            >
              <p
                className={`text-sm font-[800] ${searchParams.get('tab') === item.value ? 'text-[#333333] ' : 'text-[#808080]'}`}
              >
                {item.name}
              </p>
              <div
                className={`h-[4px] w-full ${searchParams.get('tab') === item.value ? 'bg-[#4CAF50]' : 'bg-[#E6E7EB]'} rounded-[10px]`}
              ></div>
            </div>
          ))}
        </div>
        {searchParams.get('tab') === TAB_CONST.ARTICLES && <ArticlesComponent />}
        {searchParams.get('tab') === TAB_CONST.REQUESTS && <RequestComponent />}
        {searchParams.get('tab') === TAB_CONST.SUBMISSIONS && <ResponseComponent />}
        {searchParams.get('tab') === TAB_CONST.PROFILE && <ProfileComponent />}
        {searchParams.get('tab') === TAB_CONST.AWARDED_TWIGS && <AwardedPointsComponent />}
        {searchParams.get('tab') === TAB_CONST.INVESTMENTS && <InvestmentsComponent />}
        {searchParams.get('tab') === TAB_CONST.INVESTORS && <MyArticleInvestorsComponent />}
      </div>
    </div>
  );
};

export default ManageArticle;
